﻿import { createMiddleware } from 'redux-beacon';
import debounceEvent from '@redux-beacon/debounce-event';
import { addMiddleware } from 'redux-dynamic-middlewares';
import GoogleTagManager from 'middlewares/googleTagManager';
import GoogleAnalytics4EventType from 'enums/googleAnalytics4EventType';
import { getGoogleAnalytics4Event } from 'services/googleAnalytics4EventBuilder';
import googleAnalytics4Event from './actions';

/**
 * The eventsMap function is a mapping of Redux actions to GoogleAnalytics4 events.
 * It returns an array of GoogleAnalytics4 events, which are objects with the following shape:
 * {
 *   eventType: string, // The name of the event (e.g., 'track')
 *   fieldsObj: object, // An object containing all properties for this event type (e.g., {eventName})
 * }
 *
 * @param action Determine which event to return
 *
 * @return An array of events
 */
const eventsMap = (action) => {
  if (action.type === googleAnalytics4Event.type) {
    const payload = action.payload;
    const event = debounceEvent(
      100,
      getGoogleAnalytics4Event(GoogleAnalytics4EventType.Event, payload.eventName, payload.customProperties)
    );
    return event;
  }

  return [];
};

const googleTagManager = new GoogleTagManager();
const searchResultsGoogleTagManagerMiddleware = createMiddleware(eventsMap, googleTagManager.getTarget());
addMiddleware(searchResultsGoogleTagManagerMiddleware);
